module.exports = __webpack_public_path__ + "static/media/none.18dc82e9.svg";